import { motion } from "framer-motion";
import { Braces, ShieldAlert, Database, Clock, BarChart3, BellRing, Sparkles } from "lucide-react";
import { Reveal } from "@/components/Chapter";
import { useContent } from "@/content";

const ICONS = { Braces, ShieldAlert, Database };

export const CourseCards = ({ onPick }) => {
  const { COURSES } = useContent();
  return (
  <div className="grid md:grid-cols-3 gap-6 mb-16 md:mb-20" data-testid="course-cards">
    {COURSES.map((c, i) => {
      const Icon = ICONS[c.icon] || Sparkles;
      return (
        <Reveal key={c.title} delay={i * 0.1} className="h-full">
          <motion.article
            whileHover={{ y: -8 }}
            transition={{ type: "spring", stiffness: 260, damping: 20 }}
            className="group relative flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-7 shadow-sm hover:shadow-xl hover:shadow-slate-900/5 hover:border-amber-400/60 transition-colors duration-500 overflow-hidden"
            data-testid={`course-card-${i}`}
          >
            <span className="absolute top-5 right-5 rounded-full bg-slate-100 border border-slate-200 px-2.5 py-1 font-mono text-[9px] tracking-[0.2em] uppercase text-slate-500">Coming soon</span>
            <span className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#0B1528] transition-transform duration-500 group-hover:-rotate-6 group-hover:scale-110">
              <Icon className="h-6 w-6 text-amber-400" />
            </span>
            <h3 className="text-lg sm:text-xl font-semibold text-[#0B1528] pr-24">{c.title}</h3>
            <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-500">
              <span className="inline-flex items-center gap-1.5"><BarChart3 className="h-3.5 w-3.5 text-amber-500" />{c.level}</span>
              <span className="inline-flex items-center gap-1.5"><Clock className="h-3.5 w-3.5 text-amber-500" />{c.duration}</span>
            </div>
            <p className="mt-4 text-sm text-slate-500 leading-relaxed">{c.desc}</p>
            <ul className="mt-5 space-y-2 flex-1">
              {c.topics.map((t, j) => (
                <motion.li
                  key={t}
                  initial={{ opacity: 0, x: -12 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.2 + j * 0.06 }}
                  className="flex items-start gap-2.5 text-sm text-slate-600"
                >
                  <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-amber-400 shrink-0" />
                  {t}
                </motion.li>
              ))}
            </ul>
            <button
              onClick={() => onPick(c.title)}
              data-testid={`course-notify-${i}`}
              className="mt-7 inline-flex w-fit items-center gap-2 rounded-full border border-slate-300 bg-white px-4 py-2 text-xs font-semibold text-slate-700 hover:border-amber-500 hover:bg-amber-500 hover:text-[#0B1528] active:scale-95 transition-all duration-300"
            >
              <BellRing className="h-3.5 w-3.5" />
              Notify me about this course
            </button>
          </motion.article>
        </Reveal>
      );
    })}
  </div>
);
};
